// Professional fee vs Government fee lines — the one place the web app decides how a
// quotation / invoice line is taxed, so every screen and PDF agrees with the backend
// (ca-backend/utils/invoiceMath.js).
//   professional (default) : the firm's own fee, GST applies
//   government             : statutory / out-of-pocket fee paid on the client's behalf.
//                            No GST by default (pass-through); a line can opt in with gst_applies.

export const GST_RATE = 18;

const truthy = (v) => v === true || v === 'true' || v === 1 || v === '1';

export const isGovt = (it) => !!it && it.charge_type === 'government';
export const lineGstApplies = (it) => (isGovt(it) ? truthy(it.gst_applies) : true);
export const isPassThrough = (it) => isGovt(it) && !truthy(it.gst_applies);

export const lineGross = (it) => Number(it.quantity || 1) * Number(it.rate || 0);
export const lineDiscount = (it) => {
  const amt = lineGross(it);
  if (it.discount_type === 'percentage') return amt * Number(it.discount_value || 0) / 100;
  if (it.discount_type === 'fixed') return Number(it.discount_value || 0);
  return 0;
};
export const lineNet = (it) => lineGross(it) - lineDiscount(it);

// Totals for a quotation (single "GST @18%" line — the CGST/SGST/IGST split is decided on the invoice).
export function quoteTotals(items, gstRegistered = true) {
  const list = items || [];
  const taxable = list.filter(it => !isPassThrough(it)).reduce((s, it) => s + lineNet(it), 0);
  const passThrough = list.filter(isPassThrough).reduce((s, it) => s + lineNet(it), 0);
  const gst = gstRegistered ? taxable * GST_RATE / 100 : 0;
  return {
    taxable, passThrough, gst,
    total: taxable + gst + passThrough,
    hasGovt: list.some(isGovt),
    professional: list.filter(it => !isGovt(it)),
    government: list.filter(isGovt),
  };
}

// Government-fee-looking expense categories (task expenses ledger) → billed as pass-through.
// Vendor / professional charges are the firm's own cost-plus billing, so they keep GST.
export const expenseDefaultsToGovt = (category) => !/professional|vendor|consult|travel|courier/i.test(String(category || ''));
